<template lang="pug">
  q-page.chipping.q-pa-sm
    .row.gutter-md
      .col-12
        geometry-editor(:d="d", :r="r", :z="z", :d_eff="d_eff", :d_flat="d_flat", :ap="ap", :ae="ae", :vc="vc", :vf="vf", :fz="fz")
    .row.gutter-md
      .col-12
        q-card
          q-card-main
            .row.gutter-md
              .col-6
                q-field(label-width="2", helper="axial doc")
                  q-input(v-model="ap", type="number" suffix="mm")
                  div(slot="label", v-katex="'a_p'")
                q-field(label-width="2", helper="radial doc")
                  q-input(v-model="ae", type="number" suffix="mm")
                  div(slot="label", v-katex="'a_e'")
                q-field(label-width="2", helper="feed rate")
                  q-input(v-model="vf", type="number" suffix="mm/min")
                  div(slot="label", v-katex="'v_f'")
              .col-6
                q-field(label-width="2", helper="material removal rate")
                  div
                    span {{Q}}
                    span(v-katex="'\\\\frac{\\\\text{cm}^3}{\\\\text{min}}'")
                  div(slot="label", v-katex="'Q'")
</template>

<script>
import CuttingParameters from '@/lib/cutting-parameters.js';
import CuttingDataMixin from '@/mixins/cutting-data.js';
import GeometryEditor from '@/components/GeometryEditor.vue';

export default {
  name: 'performance',
  components: {
    GeometryEditor
  },
  mixins: [CuttingDataMixin],
  data: function ()  {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
